export const  SplitDate = (dateInput) =>{
    let date;
    
    try {
        date = new Date(dateInput.replace(/-/g, '/'));
        if (isNaN(date.getTime())) {
            throw new Error('Invalid date.');
        }
    } catch (error) {
        console.error('Failed to create Date object:', error);
        return '';
    }

    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);

    return {
        year: year,
        month: month,
        day: day
    };
}
